import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AppRoutes } from '@rx-applications/clientsite/shared/router/data-access';

@Component({
  selector: 'rx-legacy-hotel-info-check-guard',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppGuardComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit() {
    if (this.router.url.match(/\/pwastart/i)) {
      const host = location.hostname.slice(location.hostname.indexOf('roomex'));
      setTimeout(
        () => location.replace(`${location.protocol}//login.${host}/`),
        500
      );
      return;
    }

    const [, hotelId] = this.router.url.match(
      /\w[,-]*\.(\d+)\.(booknow|hotelinfo)\.html/i
    ) || [null, null];

    if (hotelId && typeof +hotelId === 'number') {
      this.router.navigateByUrl(`/book/hotels/${hotelId}`, {
        skipLocationChange: true,
      });
      return;
    }

    const oldReportsRoute = this.router.url.includes(AppRoutes.Reports);
    const oldReportingRoute = this.router.url.includes(AppRoutes.Reporting);
    if (oldReportingRoute || oldReportsRoute) {
      this.router.navigate([AppRoutes.Analytics]);
      return;
    }

    this.router.navigate([AppRoutes.Book]);
  }
}
